// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2025-11-27 00:52:52 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158688 $
//  Purpose   : uix gndo support
// =============================================================================
export const templates = true;
export const parts = true;
export const nodemenu = true;
import * as views from './views';
export { views };
export const dashpanels = true;
